import React from 'react';
import './EmptyState.css';

export interface EmptyStateProps {
  message?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  message = 'Sepetinizde ürün bulunmuyor.' 
}) => {
  return (
    <div className="empty-state">
      {message}
    </div>
  );
};

export default EmptyState;

